import { useEffect, useState } from "react";
import { selectOrderDeliveryLimits, selectShippingAddressSelected, useSelector } from "@jti/store";
import { useCountry } from "@jti/ui";
import { checkIfCityLimitModeEnabled, searchForTheCity } from "../../utils";
export const useDeliveryLimit = () => {
    const [isDeliveryLimitError, setIsDeliveryLimitError] = useState(false);
    const orderDeliveryLimits = useSelector(selectOrderDeliveryLimits);
    const country = useCountry();
    const shippingAddressSelected = useSelector((state) => selectShippingAddressSelected(state, country));
    const isDeliveryLimitEnabled = !!orderDeliveryLimits?.mode && checkIfCityLimitModeEnabled(orderDeliveryLimits.mode);
    useEffect(() => {
        if (shippingAddressSelected && isDeliveryLimitEnabled) {
            const { city } = shippingAddressSelected;
            const { limits } = orderDeliveryLimits;
            if (city) {
                const matchingCitiesCount = searchForTheCity(city, limits);
                setIsDeliveryLimitError(matchingCitiesCount === 0);
            }
        }
        else {
            setIsDeliveryLimitError(false);
        }
    }, [shippingAddressSelected, isDeliveryLimitEnabled, orderDeliveryLimits]);
    return { isDeliveryLimitError };
};
//# sourceMappingURL=useDeliveryLimit.js.map